import axios from "axios";

// Sesuaikan URL dengan port backend Anda (default 5000)
const BASE_URL = `${process.env.REACT_APP_BACKEND}/api`;

const api = axios.create({
    baseURL: BASE_URL,
    withCredentials: true, // WAJIB: Agar cookie (refreshToken) bisa dikirim/diterima
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Jika backend mengirim "must_verify": true
        if (error.response && error.response.data.must_verify) {
            // Paksa redirect menggunakan window.location agar aplikasi me-refresh state
            if (window.location.pathname !== '/manager/profile') {
                window.location.href = '/manager/profile';
            }
        }
        return Promise.reject(error);
    }
);
export default api;